export default [
  {
    path: '/rights/',
    component: require('@/pages/rights/RightsPage.vue')
  },
  {
    path: '/rights/profiles',
    component: require('@/pages/rights/RightsConfigs.vue')
  }
]



// WEBPACK FOOTER //
// ./src/routes/rights.js